import formName from 'constants/formName'
import { actions } from 'data'
import { call, put } from 'redux-saga/effects'

import { goToStep } from './common'

export default function* turnOffStep() {
  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))
  yield call(goToStep, 'disabletotp')
}
